"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.glossaryHighlighter = exports.setTooltip = void 0;
const createTemplate = (content, showCloseButton, title) => {
    const template_title = `<div class="tippy-content__title">${title}</div>`;
    const template_description = `<div class="tippy-content__description">${content}</div>`;
    const template_close = '<div class="tippy-content__close"></div>';
    return `${title ? template_title : ''}${template_description}${showCloseButton ? template_close : ''}`;
};
const getDynamicContent = (element) => {
    const el = document.getElementById(element);
    return el ? el.dataset.dynamiccontent : undefined;
};
const setTooltip = ({ content, element, optionsOverride, showCloseButton = true, title, }) => {
    const template = createTemplate(content, showCloseButton, title);
    const onShowHandler = (instance) => {
        if (showCloseButton) {
            const closeButton = instance.popperChildren.content.querySelector('.tippy-content__close');
            closeButton.addEventListener('click', function () {
                instance.hide();
            });
        }
        const newContent = getDynamicContent(instance.reference.id);
        if (newContent) {
            instance.setContent(createTemplate(newContent, showCloseButton, title));
        }
    };
    const options = Object.assign({ content: template, onShow: onShowHandler, allowHTML: true, animation: 'scale', arrow: true, duration: 200, flipBehavior: ['right', 'top'], interactive: true, maxWidth: 300, placement: 'right', theme: 'glossary', trigger: 'click mouseenter', zIndex: 9999, appendTo: document.body }, optionsOverride);
    tippy(element, options);
};
exports.setTooltip = setTooltip;
const glossaryHighlighter = (selector, element, customOptions) => {
    window.GlossaryHighlight.highlightItems(selector, element, customOptions);
};
exports.glossaryHighlighter = glossaryHighlighter;
//# sourceMappingURL=tooltip.util.js.map